import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Observable} from "rxjs";
import {UpdateCheckService} from "../../services/update-check.service";

@Component({
    selector: "common-update-notice",
    template: `
        <div class="update-notice" *ngIf="visible$ | async">
            <mat-icon class="update-notice__icon">system_update_alt</mat-icon>
            <div class="update-notice__body">
                <div class="update-notice__text">
                    A new version of Logivice is available.
                </div>
                <button class="update-notice__action" type="button" (click)="update()">
                    Update now
                </button>
            </div>
            <button class="update-notice__close" type="button" (click)="dismiss()" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    `,
    styles: [
        `
            .update-notice {
                position: fixed;
                bottom: 50px;
                left: 80px;
                z-index: 1200;
                display: flex;
                align-items: flex-start;
                gap: 10px;
                max-width: 320px;
                padding: 12px 14px;
                background: linear-gradient(to right, #1976d2, #ffffff 40%);
                color: rgba(0, 0, 0, 0.87);
                border: 2px solid #1976d2;
                border-radius: 6px;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
                font-size: 13px;
                line-height: 1.4;
                animation: update-notice-in 0.25s ease-out;
            }

            .update-notice__icon {
                color: #ffffff;
                flex: 0 0 auto;
            }

            .update-notice__body {
                flex: 1 1 auto;
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            .update-notice__text {
                padding-top: 2px;
            }

            .update-notice__action {
                align-self: flex-start;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                padding: 6px 14px;
                background: #1976d2;
                color: #ffffff;
                font-size: 13px;
                font-weight: 500;
            }

            .update-notice__action:hover {
                background: #145ca4;
            }

            .update-notice__close {
                flex: 0 0 auto;
                border: none;
                background: transparent;
                cursor: pointer;
                padding: 0;
                margin: -2px -4px 0 0;
                color: rgba(0, 0, 0, 0.54);
                line-height: 1;
            }

            .update-notice__close:hover {
                color: rgba(0, 0, 0, 0.87);
            }

            .update-notice__close mat-icon {
                font-size: 18px;
                width: 18px;
                height: 18px;
            }

            @keyframes update-notice-in {
                from {
                    opacity: 0;
                    transform: translateY(12px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateNoticeComponent {

    public visible$: Observable<boolean>;

    public constructor(private updateCheck: UpdateCheckService) {
        this.visible$ = this.updateCheck.visible$;
    }

    public update(): void {
        this.updateCheck.activateAndReload();
    }

    public dismiss(): void {
        this.updateCheck.dismiss();
    }
}